module.exports = __webpack_public_path__ + "img/reloj-primary.d828ac76.svg";